import { Routes, Route, Outlet, Navigate, useOutletContext } from 'react-router'
import Meta from '@components/Meta/Meta'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import ErrorPage from '@components/ErrorBoundary/ErrorPage/ErrorPage'
import NotFound from './NotFound/NotFound'
import Login from './Login/Login'
import PageLayout, {
  PageLayoutContext
} from 'src/layouts/PageLayout/PageLayout'
import RequireAuth from '@components/RequireAuth/RequireAuth'
import RequireGuest from '@components/RequireGuest/RequireGuest'
import DataSet from './DataSet/DataSet'
import DataSets from './DataSets/DataSets'
import Profile from './Profile/Profile'
import ProfileData from './Profile/ProfileData/ProfileData'
import Queries from './Queries/Queries'
import Query from './Query/Query'
import Dashboards from './Dashboards/Dashboards'
import Dashboard from './Dashboard/Dashboard'
import Favorites from './Favorites/Favorites'
import { useUserAcl } from '@hooks/useUserAcl'
import { useAppDispatch } from 'universal-scripts'
import { useEffect } from 'react'
import { isWideViewport } from '@utils/viewportUtils'
import { openSidebar } from 'src/store/slices/ui'
import QueryBuilder from './QueryBuilder/QueryBuilder'
import Explore from './Explore/Explore'
import DashboardBuilder from './DashboardBuilder/DashboardBuilder'
import ConnectorsDialog from '@components/dialog/ConnectorsDialog/ConnectorsDialog'
import DashboardEmbed from './DashboardEmbed/DashboardEmbed'
import ConnectorsList from './Profile/ConnectorsList/ConnectorsList'
import Signup from './Signup/Signup'
import Pricing from './Pricing/Pricing'
import TokensList from './Profile/TokensList/TokensList'

const RequireBetatester = () => {
  const acl = useUserAcl()
  const isBetatester = acl?.includes('betatester')
  const context = useOutletContext<PageLayoutContext>()
  if (!isBetatester) {
    return <Navigate to="/" replace />
  }
  return <Outlet context={context} />
}

export default function App() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (isWideViewport(1700)) {
      dispatch(openSidebar())
    }
  }, [dispatch])

  return (
    <ErrorBoundary errorComponent={ErrorPage}>
      <Meta />
      <Routes>
        <Route element={<RequireAuth />}>
          <Route element={<PageLayout />}>
            <Route path="/" element={<DataSets />} index />
            <Route path="/data-sets" element={<DataSets />} />
            <Route path="/data-sets/:id" element={<DataSet />} />
            <Route path="/queries" element={<Queries />} />
            <Route path="/queries/:id" element={<Query />} />
            <Route path="/query-builder/:id" element={<QueryBuilder />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/dashboards" element={<Dashboards />} />
            <Route path="/dashboards/:id" element={<Dashboard />} />
            <Route
              path="/dashboard-builder/:id"
              element={<DashboardBuilder />}
            />
            <Route path="/profile" element={<Profile />}>
              <Route path="" element={<ProfileData />}>
                <Route
                  path="connectors/assoc/:id"
                  element={<ConnectorsDialog mode="assoc" />}
                />
              </Route>
              <Route path="connectors" element={<ConnectorsList />}>
                <Route
                  path="info/:id"
                  element={<ConnectorsDialog mode="info" />}
                />
              </Route>
              <Route path="tokens" element={<TokensList />}>
                <Route
                  path="info/:id"
                  // element={<ConnectorsDialog mode="info" />}
                />
              </Route>
            </Route>
            <Route path="/pricing" element={<Pricing />} />
            <Route element={<RequireBetatester />}>
              <Route path="/favorites" element={<Favorites />} />
            </Route>
          </Route>
        </Route>
        <Route element={<RequireGuest />}>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </Route>
        <Route path="/embed/dashboards/:id" element={<DashboardEmbed />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ErrorBoundary>
  )
}
